<script lang="ts">
  import { cn } from '@shared/utils';

  export let classes = '';
</script>

<div class="{cn('custom-gradient relative z-[3] h-full w-full rounded-lg', classes)}"></div>

<style lang="scss">
  .custom-gradient {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%),
      linear-gradient(45deg, #6bbdff 0%, #a883fa 50.5%, #fbb49d 100%);
  }
</style>
